export default {
  CapacityTon: 'CapacityTon',
  HeightMeter: 'HeightMeter',
  LengthMeter: 'LengthMeter',
  NewMeasurementAdd: 'New Measurement Add',
  NewCurrencyAdd: 'New Currency Add',
  MaesurementUpdate: 'Maesurement Update',
  MeasurementRemoved: 'Measurement Removed',
  UserGroupRemoved: 'User Group Removed',
  TypeMeasurement: 'Type Measurement',
  DecimalPlaces: 'Decimal Places',
  Order: 'Order',
  Slug: 'Slug',
  Symbol: 'Symbol',
  Enable: 'Enable',
  Disable: 'Disable',
  WidthMeter: 'WidthMeter',
  capacity: 'Capacity',
  length: 'Length',
  width: 'Width',
  height: 'Height',
  hour: 'Hour',
  minutes: 'Minutes',
  kilometer: 'Kilometer',
  meter: 'Meter',
  tons: 'Tons',
  kilogerams: 'Kilograms',
  grams: 'Grams',
  unit: 'Unit'
}
